// Dependencies
import { createAction, createSlice } from '@reduxjs/toolkit';
import { PayloadAction } from '@reduxjs/toolkit/dist/createAction';
// Types
import { Picture } from '../../picture/objects/picture';
import { RoadbookConfiguration } from '../objects/roadbookConfiguration';
import { RoadbookCategory } from '../../roadbookCategory/objects/roadbookCategory';
import { RoadbookConfigurationState } from '../objects/roadbookConfigurationState';
import { RoadbookConfigurationIdentifier } from '../objects/roadbookConfigurationIdentifier';

const addCustomPictures = createAction<Picture[]>('PICTURE_ADD_CUSTOM_PICTURES');


const initialState: RoadbookConfigurationState = {
  module_modal_open: false,
  module_index: 0,
  roadbook_configuration: null,
  roadbook_categories: [],
  roadbook_category_open: false,
  roadbook_category_selected: null,
  roadbook_picture_selected: null,
  selected_module: RoadbookConfigurationIdentifier.SUMMARY,
};

export const roadbookConfigurationSlice = createSlice({
  name: 'roadbook_configuration',
  initialState,
  reducers: {
    addModule: (state) => {
      if (state.roadbook_configuration !== null) {
        state.roadbook_configuration.modules.push({
          identifier: state.selected_module,
          picture: null,
          category: null,
          activated: true,
        });
      }
      state.module_modal_open = false;
    },
    deleteModule: (state, action: PayloadAction<number>) => {
      if (state.roadbook_configuration !== null) {
        const modules = [...state.roadbook_configuration.modules];
        modules.splice(action.payload, 1);
        state.roadbook_configuration.modules = modules;
      }
    },
    resetRoadbookConfiguration: (state) => {
      state.roadbook_categories = [];
    },
    setRoadbookCategories: (state, action: PayloadAction<RoadbookCategory[]>) => {
      state.roadbook_categories = action.payload;
    },
    setRoadbookConfiguration: (state, action: PayloadAction<RoadbookConfiguration[]>) => {
      if (action.payload.length > 0) {
        state.roadbook_configuration = action.payload[0];
      } else {
        state.roadbook_configuration = {
          modules: []
        };
      }
    },
    toggleAddModule: (state) => {
      state.module_modal_open = !state.module_modal_open;
    },
    updateModuleCategory: (state, action: PayloadAction<{module_index: number, value: RoadbookCategory}>) => {
      if (state.roadbook_configuration !== null) {
        const modules = [...state.roadbook_configuration.modules];
        const module = {...modules[action.payload.module_index]};
        module.category = action.payload.value;
        modules[action.payload.module_index] = module;
        state.roadbook_configuration.modules = modules;
      }
    },
    updateModuleIndex: (state, action: PayloadAction<number>) => {
      state.module_index = action.payload;
    },
    updateRoadbookConfigurationModules: (state, action: PayloadAction<{dragIndex: number, hoverIndex: number}>) => {
      if (state.roadbook_configuration !== null) {
        const modules = [...state.roadbook_configuration.modules];
        modules.splice(action.payload.dragIndex, 1);
        modules.splice(action.payload.hoverIndex, 0, state.roadbook_configuration.modules[action.payload.dragIndex]);
        state.roadbook_configuration.modules = modules;
      }
    },
    updateSelectedModule: (state, action: PayloadAction<RoadbookConfigurationIdentifier>) => {
      state.selected_module = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addCustomPictures, (state, action) => {
        if (state.roadbook_configuration !== null) {
          const modules = [...state.roadbook_configuration.modules];
          const module = {...modules[state.module_index]};
          module.picture = action.payload.length > 0 && action.payload[0] ? action.payload[0] : null;
          modules[state.module_index] = module;
          state.roadbook_configuration.modules = modules;
        }
      })
  },
});

export const {
  addModule,
  deleteModule,
  resetRoadbookConfiguration,
  setRoadbookCategories,
  setRoadbookConfiguration,
  toggleAddModule,
  updateModuleIndex,
  updateModuleCategory,
  updateRoadbookConfigurationModules,
  updateSelectedModule,
} = roadbookConfigurationSlice.actions;

export default roadbookConfigurationSlice.reducer;